import { Notification as NotificationBase } from '@progress/kendo-react-notification'
import React from 'react'

import { type NotificationItem } from '~/utils'

import styles from './Notification.css'

export type NotificationProps = NotificationItem

export const Notification = React.memo(
  ({ content, style, timestamp }: NotificationProps) => {
    const isValidElement = React.useMemo(
      () => React.isValidElement(content),
      [content],
    )

    return (
      <NotificationBase key={timestamp} type={{ icon: !isValidElement, style }}>
        {isValidElement ? (
          content
        ) : (
          <span className={styles.span}>{content}</span>
        )}
      </NotificationBase>
    )
  },
)
